module.exports = __webpack_public_path__ + "img/saudi-arabia-logo-icon.56736474.png";